<script>
import { parseJWT } from '../../../clavo-shared/functions/util'
export default {
  name: 'IntegrationCallback',
  components: {},

  data() {
    return {}
  },
  created() {
    let teamId = this.$route.query.teamId
    let calledFrom = this.$route.query.calledFrom
    let code = this.$route.query.code
    let state = this.$route.query.state

    let system = 'slack'
    if (state) {
      let parsedJWT = parseJWT(state)
      let installOptions = parsedJWT.installOptions
      let metadata = installOptions.metadata
      calledFrom = metadata.calledFrom
      system = installOptions.system
      teamId = metadata.teamId
    }
    let guild_id
    if (system === 'discord') {
      guild_id = this.$route.query.guild_id
    }

    let path = '/?teamId=' + teamId + '&system=' + system + '&calledFrom=' + calledFrom + '&code=' + code + '&state=' + state

    if (guild_id) {
      path += '&guild_id=' + guild_id
    }
    path += '&tabName=TeamIntegrationsSettings#AdminSettings'
    this.$router.push({
      path,
    })
  },
  methods: {},
}
</script>
